
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import useTranslation from "next-translate/useTranslation";
import { Card, CardBody, Col, Row } from "reactstrap";
import BaseLayout from "@components/BaseLayout";
import TranslatedHtml from "@components/common/TranslatedHtml";
const AboutPage: React.FC = () => {
    const { t } = useTranslation("common");
    return <BaseLayout pageTitle={t("page.about.title")}>
    <Card>
      <CardBody>
        <Row>
          <Col sm={8}>
            <h1>{t("page.about.heading")}</h1>
            <TranslatedHtml content="page.about.intro"/>
          </Col>
        </Row>
      </CardBody>
    </Card>
  </BaseLayout>;
};
export default AboutPage;

    async function __Next_Translate__getStaticProps__18c4f5170dc__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/about',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__18c4f5170dc__ as getStaticProps }
  